import Conf from 'site-config';
import MShare from '@mfex/mshare';
import {getAssetURL} from 'common/util';

export interface ShareData {
    title?: string;
    desc?: string;
    link?: string;
    imgUrl?: string;
    btnIcon?: string;
    success?: () => void;
}

const {TITLE, DESC} = Conf;

const shareConfig = {
    title: TITLE,
    desc: DESC,
    imgUrl: getAssetURL('img/logo.png')
};

const instance = new MShare({
    ...shareConfig,
    link: location.href
});

/**
 * 更新分享配置信息
 * @param {Object} config 分享配置信息
 * @param {boolean} isWhiteIcon 是否使用白色 icon
 */
export function updateShareConfig(config: ShareData, isWhiteIcon?: boolean) {
    const btnIcon = isWhiteIcon
        ? `${location.protocol}${getAssetURL('img/icon-share-w.png')}`
        : `${location.protocol}${getAssetURL('img/share-black.png')}`;

    instance.updateConfig({
        imgUrl: getAssetURL('img/logo.png'),
        ...config,
        btnIcon
    });
}

export default {};
